import React, { useEffect, useState } from 'react';
import './RechargeCard.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { getConnectorStatus } from '../../services/rechargeService';
import { formatKw, getFormatedTimeMiliSeconds } from '../../utils/format';
import { useSocketContext } from '../../websocket/websocketProvider';
import thunder_charger_list from '../../assets/thunder_charger_list.svg';
import { BatteryIcon } from '../../components/BatteryIcon/BatteryIcon';

type RechargeCardProps = {
  recharge: any;
};

const RechargeCard: React.FC<RechargeCardProps> = ({ recharge }) => {
  const navigate = useNavigate();
  const [connectorStatus, setConnectorStatus] = useState<any>();
  const initialDate: Date = new Date(recharge?.startTime);
  const [totalMiliSeconds, setTotalMiliSeconds] = useState(
    new Date().getTime() - initialDate.getTime()
  );
  const value = useSocketContext();
  const location = useLocation();

  const routePaths = location.pathname.split('/');

  useEffect(() => {
    let socketMessagesJson = value.messages?.map((jsonString) =>
      JSON.parse(jsonString)
    );

    socketMessagesJson.forEach((json) => {
      if (
        json?.connectorStatus &&
        json?.connectorStatus.transaction?.chargePointId ===
          recharge?.chargePointId &&
        json?.connectorStatus.transaction?.connectorId === recharge?.connectorId
      ) {
        setConnectorStatus(json?.connectorStatus);
      }
    });
  }, [value.messages, recharge]);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentDate: Date = new Date();
      //console.log(currentDate.getTime() - initialDate.getTime());
      setTotalMiliSeconds(currentDate.getTime() - initialDate.getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchConnectorStatus(recharge?.chargePointId, recharge?.connectorId);
  }, [recharge]);

  const fetchConnectorStatus = async (
    chargerId: string,
    connectorId: number
  ) => {
    try {
      const cStatus = await getConnectorStatus(chargerId, connectorId);
      setConnectorStatus(cStatus[0]);
    } catch (error) {
      console.error('Erro ao buscar recargas em andamento', error);
    }
  };

  function navigateRechargeInfos() {
    navigate(
      `/${routePaths[1]}/recharge/${recharge?.chargePointId}/${recharge?.connectorId}`,
      { state: { ids: recharge } }
    );
  }

  return (
    <div className='timePowerContainer' onClick={() => navigateRechargeInfos()}>
      <div className='flexColumn'>
        <div className='label1'>Tempo</div>
        <div className='value1'>
          {getFormatedTimeMiliSeconds(totalMiliSeconds)}
        </div>
      </div>
      <div className='flexColumn'>
        {connectorStatus?.transaction?.uv && (
          <>
            <div className='label1'>Veículo</div>
            <div className='value1'>
              {connectorStatus?.transaction?.uv?.uvName}
            </div>
          </>
        )}
      </div>
      <div className='flexColumn' style={{ minWidth: '44px' }}>
        <div style={{ margin: 'auto' }}>
          {connectorStatus?.cmcType.toLowerCase() === 'dc' &&
          connectorStatus?.soC != null &&
          connectorStatus?.soC != undefined ? (
            <>
              <div
                className='label1'
                style={{ height: 20, width: '20px', margin: 'auto' }}
              >
                <BatteryIcon
                  percentage={connectorStatus?.soC}
                  size={22}
                  color='#00ffa3'
                />
              </div>
              <div className='value1'>
                {`${
                  connectorStatus.soC % 1 < 0.5
                    ? Math.floor(connectorStatus.soC)
                    : Math.ceil(connectorStatus.soC)
                }%`}
              </div>
            </>
          ) : null}
        </div>
      </div>
      <div className='kWhContainer'>
        <img
          className='thunder-charge-icon'
          alt='thunder-charge-icon'
          src={thunder_charger_list}
        />
        <div className='kWhValue'>{formatKw(connectorStatus?.meterKWH)}</div>
        <div className='kWhText'>kWh</div>
      </div>
      {/* <div className='flexColumn kWWrapperColumn'>
        {/* <div className='timePowerLabel'>Potência</div>
        <div className='powerValue'>
          {formatKw(connectorStatus?.chargeRateKW)} kW
        </div>
      </div> */}
    </div>
  );
};

export default RechargeCard;
